import React from 'react';

export const DialogFooter = ({ children, className }) => (
  <div className={`ct-dialog__footer ${className || ''}`}>{children}</div>
);
